<template> 
  <div>
  <div class="kb-table-title">Product Result</div>

  <div class="kb-table-title-1 q-mt-sm" v-if="$q.screen.xs">Item</div>
  <div class="">
    <q-table :grid="$q.screen.xs" class="pr-table" :rows="productSearchResults" :columns="columns" row-key="name"
      :pagination="pagination" square>
      <template v-slot:header="props">
        <q-tr :props="props" class='header-row-color text-white'>
          <q-th auto-width class="text-center">QUICK VIEW</q-th>
          <q-th v-for="col in props.cols" :key="col.name" :props="props" class="">
            {{ col.label.toUpperCase() }}
          </q-th>
        </q-tr>
      </template>

      <template v-slot:body="props">
        <q-tr :props="props" :key="`m_${props.row.index}`" :class="props.pageIndex % 2 != 0 ? 'table-row-bg-gray' : ''">
          <q-td auto-width class="text-center">
            <q-icon @click="props.expand = !props.expand" class="cursor-pointer" name="visibility" size='x-large'/>
          </q-td>
          <q-td v-for="col in props.cols" :key="col.name" :props="props">
            <template v-if="col.value">
              <stock-message v-if='col.name?.toLowerCase() === "stock"' :showQuantity='col.value.showStock' :quantity='col.value.stockQuantity' :status='col.value.stockStatus'></stock-message>
              <span v-else :class="[col.name === 'name' || col.name === 'price' ? 'bold-font' : '']">
                <template v-if="col.name?.toLowerCase() === 'stock'">
                <!-- {{ col.value }} -->
                <template v-if="col.value?.showStock">
                  <span v-html='col.value?.stockQuantity'></span>
                </template>
                <template v-else>
                  <span v-html='col.value?.stockStatus'></span>
                </template>
              </template>
              <template v-else>
                <span v-if='col.name?.toLowerCase() === "name"' class="cursor-pointer" @click="props.expand = !props.expand" v-html='col.value'></span>
                <span v-else v-html='col.value'></span>
              </template>
              </span>
            </template>
            <template v-else>
              <q-spinner-dots color="primary" size="2em" />
            </template>
          </q-td>
        </q-tr>
        <q-tr v-if="props.expand" :props="props">
          <q-td colspan="100%" class="detail-card">
            <q-slide-transition>
            <RowDetailCard class="q-px-md q-py-md"  :productId="props.row.id" :showQuantity='props.row.pricing?.ShowStock' :quantity='props.row.pricing?.StockQuantity' :status='props.row.pricing.StockStatus'  @close="props.expand = !props.expand" />
          </q-slide-transition>
          </q-td>
        </q-tr>
      </template>

      <template v-slot:item="props">
        <div class="q-pa-0 col-xs-12 col-sm-6 col-md-4">
          <q-card class="row-card" :class="props.pageIndex % 2 != 0 ? 'table-row-bg-gray' : ''">
            <q-card-section >
              <div class="q-pb-sm"><strong class="text-darkgray">{{ props.row.name }}</strong></div>
              <div>
              <span class="text-gray">SKU:</span> <strong class="text-darkgray">{{ props.row.sku }}</strong>
              </div>
              <div>
                <span class="text-gray">PRICE:</span> <strong class="text-darkgray">{{ props.row?.pricing?.ProductsPrice?.Price }}</strong>
              </div>
              <div class="row-card--bottom q-pt-md">
                <div>
                  <stock-message :showQuantity='props.row.pricing?.ShowStock' :quantity='props.row.pricing?.StockQuantity' :status='props.row?.pricing?.StockStatus'></stock-message>
                </div>
                <div>
                  <q-btn outline @click="props.expand = !props.expand" class="btn-quick-view">
                    <q-icon class="eye-icon" name="visibility" /><span class="q-pl-sm">Quick View</span>
                  </q-btn>
                </div>
              </div>
              <RowDetailCard :class="{'q-pt-md q-px-sm': $q.screen.xs}" v-if="props.expand"  :productId="props.row.id" :showQuantity='props.row.pricing?.ShowStock' :quantity='props.row.pricing?.StockQuantity' :status='props.row.pricing?.StockStatus' @close="props.expand = !props.expand" />
            </q-card-section>
          </q-card>
        </div>
      </template>
      <template v-slot:bottom="pagination">
        <TablePagination :scope="pagination" @update:rowsPerPage='updateRowsPerPage' :rowsPerPageOptions='rowsPerPageOptions' @updatePage='updatePage' :disableTableSize='false'/>
      </template>
    </q-table>
  </div>
  </div>
</template>

<script>
 /* eslint-disable */
  export default {
    name: 'ProductResultsTable',
  }
</script>
<script setup>
import RowDetailCard from './RowDetailCard.vue';
import TablePagination from './TablePagination.vue';
import { ref,  computed } from "vue";
import { storeToRefs } from 'pinia'
import { useSearchStore } from '../../stores/search-store'
import StockMessage from './StockMessage.vue';

const rowsPerPageOptions = [5, 10, 25, 50]
const columns = [
  {
    name: 'name',
    required: true,
    label: 'Item',
    align: 'left',
    field: row => row.subtitle ? `${row.name}<br/>${row.subtitle}` : row.name,
    format: val => `${val}`,
    sortable: true
  },
  { name: 'sku', align: 'left', label: 'SKU', field: 'sku', sortable: true },
  { name: 'price', align: 'left', label: 'Price', field: 'price', sortable: true, field: row => row.pricing?.ProductsPrice?.Price  },
  { name: 'stock', align: 'left', label: 'Stock', field: 'stock', field: row=> {
    return row.pricing?.StockQuantity || row.pricing?.StockQuantity == '0' ? {
      stockStatus: row.pricing.StockStatus,
      stockQuantity: row.pricing?.StockQuantity,
      showStock: row?.pricing?.ShowStock
    } : null
    } }
  // { name: 'protein', label: 'Protein (g)', field: 'protein' },
  // { name: 'sodium', label: 'Sodium (mg)', field: 'sodium' },
  // { name: 'calcium', label: 'Calcium (%)', field: 'calcium', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) },
  // { name: 'iron', label: 'Iron (%)', field: 'iron', sortable: true, sort: (a, b) => parseInt(a, 10) - parseInt(b, 10) }
]

const isopen  = ref(true)
const dialog = ref()

    let pagination = {
      isFirstPage: ref(false),
      isLastPage: ref(true),
      page: ref(1),
      rowsPerPage: ref(10),
      rowsNumber: ref(0),
      sortBy: ref(null),
      descending: ref(true),
      lastPage: ref(0),
    }

    const searchStore = useSearchStore()
    const { productSearchResults, productMatchCount, productsPerPage, startPage } = storeToRefs(searchStore)
    const { searchProducts } = searchStore

    pagination.page = computed(() => Math.floor(parseInt(startPage.value) / parseInt(productsPerPage.value) + 1))
    pagination.rowsPerPage = productsPerPage
    pagination.rowsNumber = productMatchCount

    const updateRowsPerPage = (rowsPerPage) => {
      productsPerPage.value = rowsPerPage
      searchProducts()
    }

    const updatePage = (page) => {
        startPage.value = (page - 1) * productsPerPage.value
        searchProducts()
    }
    
</script>
<style lang="scss">
.pr-table {
  line-height: 1.5;
}
.q-tr{
  border: unset;
}
.q-td{
  border: unset;
}
.q-td .eye-icon {
  font-size: x-large;
}

.header-row-color {
  background-color: $primary;
}

.stock-available {
  color: #00AA2D;
  font-weight: bold;
}

.stock-inproduction {
  color: #C42424;
  font-weight: bold;
}

.kb-table-title {
  color: 'primary';
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  font-family: 'Roboto';
  font-style: normal;
  padding: 0 0 7px 0;
  @media (max-width: $breakpoint-xs) {
    padding-top: 5px;
  }
}

//custom
.q-table__grid-item .q-table__grid-item-card {
  padding: 4.68%;
}

.q-table__grid-item-row .q-table__grid-item-value {
  font-size: 14px;
  color: #000;
  font-weight: bold;
  line-height: 16.41px;
  display: inline-block;
}

.q-table__grid-item-row {
  display: block;
  letter-spacing: 0.380084px;
}

.q-table__grid-item-row .q-table__grid-item-title {
  display: inline-block;
  color: #8E8E8E;
  font-size: 14px;
  width: 50px;
}

#v-products .q-pa-md {
  padding: 0 18px 10px 18px;
}


// .q-table__grid-item-value::before{
//   content: '';
//      display: inline-block;
//      width: 15px;
//      height: 15px;
//      -moz-border-radius: 7.5px;
//      -webkit-border-radius: 7.5px;
//      border-radius: 7.5px;
//      background-color: #69b6d5;
// }
.kb-table-title-1 {
  background: #0585C8;
  color: #fff;
  text-transform: uppercase;
  // margin: 10px 21px 0 21px;
  padding: 14px;
  font-weight: 700;
}

.table-row-bg-gray {
  background-color: #F1F1F1 !important;
}

.row-card {
  border: 1px solid #F1F1F1;
  box-shadow: none;
  border-radius: 0 !important;

  &--bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

#v-products .q-table--grid .q-table__middle {
  display: none;
}

.bold-font {
  font-weight: 700;
  color: #242625;
}

.table-pagination {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.table-rows-par-page {
  display: flex;
  align-items: center;
}

@media (max-width: $breakpoint-xs) {
  .q-table__bottom {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
}
.btn-quick-view{
  text-transform: none;
}
.text-gray{
  color: #8E8E8E
}
.text-darkgray{
  color: #242625
}
</style>